import * as Yup from "yup";
import { Formik } from "formik";
import ReCAPTCHA from "react-google-recaptcha";
import { useRef, useState } from "react";
import { regionConfigs } from "../../../../config/regions";
import { postContactUs } from "../../../../services/contactUsService";
import { toast } from "react-toastify";
import MichelleMorton from "../../../../assets/png/Michelle Morton.jpeg";
// import GeoffHill from "../../../../assets/png/Geoff Hill.jpeg";
import GeoffHill from "../../../../assets/png/Geoff - Shanghai (Portrait).jpg";
import QingmeiPang from "../../../../assets/png/QingmeiPang.png";
import User_Icon from "../../../../assets/png/User_Icon.png";

const TeamMember = ({ imageSrc, name, title, email, phone }) => {
  const hasName = name?.trim().length > 0;

  return (
    <div className="flex flex-col items-center text-base text-center text-white max-md:mt-10">
      <img
        src={imageSrc}
        alt={hasName ? name : "Team member"}
        className="object-cover aspect-square w-[200px]"
      />

      {hasName ? (
        <h4 className="self-center mt-6 font-semibold leading-loose">{name}</h4>
      ) : (
        <div className="mt-6 h-[1.75rem]" /> // Reserve height for name spacing
      )}

      <div
        className={`${hasName ? "mt-2" : "mt-4"
          } font-medium leading-6 max-md:mx-1.5`}
      >
        {title}
        <br />
        <span style={{ color: "rgba(247,135,27,1)" }}>{email}</span>
        <br />
        <span style={{ color: "rgba(247,135,27,1)" }}>{phone}</span>
      </div>
    </div>
  );
};

const NZContact = () => {
  const reCaptchaRef = useRef(null);
  const [isLoading, setIsLoading] = useState(false);
  const AccSchema = Yup.object().shape({
    name: Yup.string().required("Please Enter Name"),
    lastname: Yup.string(),
    email: Yup.string()
      .email("Enter Valid Email Address")
      .required("Please Enter E-mail Address"),
    message: Yup.string().required("Please Enter message"),
    bname: Yup.string(),
    subject: Yup.string().required("Please Enter Subject"),
    phone: Yup.string().required("Please Enter Phone"),
    reCaptcha: Yup.string().required("recaptcha is a required field"),
  });
  const handleSubmitForm = (value, resetForm) => {
    const htmlForm = `
    <div style="font-size:25px">
      <div>
        <table>
          <tr style="border-top:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Subject</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;">${value?.subject ?? ""}</td>
          </tr>
          <tr style="border-top:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Name</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;">${value?.name ?? ""
      } ${value?.lastname ?? ""}</td>
          </tr>
          <tr  style="border-top:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Email</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;"><a href = "mailto:${value?.email ?? ""
      }" style="color:#551A8B;text-decoration: underline;">${value?.email ?? ""
      }</a></td>
          </tr>
          <tr style="border-top:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Business Name</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;">${value?.bname ?? ""
      }</td>
          </tr>
          <tr  style="border-top:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Phone</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;">${value?.phone ?? ""
      }</td>
          </tr>
          <tr  style="border-top:1px solid #C8C8C8;border-bottom:1px solid #C8C8C8">
            <td style="font-weight:bold; font-size:16px;padding:10px 0px;color:#000;">Message</td>
            <td style="font-size:16px;color:#86848e;font-weight:bold;padding-right:40px;max-width: 2600px;line-break: anywhere;">${value?.message ?? ""
      }</td>
          </tr>
        </table>
      <div>
    </div>
  `;

    setIsLoading(true);
    let payload = {
      HtmlContent: htmlForm,
      ApplicationId: regionConfigs.nz.applicationId,
      subject: "Contact Us form submitted on Tuatara Website",
      toEmail: value?.email,
      ReCaptchaResponse: value?.reCaptcha,
    };
    postContactUs(payload)
      .then((res) => {
        toast.success(res?.data);
        reCaptchaRef?.current?.reset();
        setIsLoading(false);

        resetForm();
      })
      .catch((err) => {
        toast.error(err?.data);
        setIsLoading(false);
      });
  };
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2">
      <div className="NZContact-right">
        <div className="lg:p-[70px] md:p-[30px] p-[10px]">
          <div>
            {/* <div className="flex relative flex-col justify-center items-center px-20 py-28 bg-neutral-700 bg-opacity-80 max-md:px-5 max-md:py-24 max-md:max-w-full"> */}
            <div className="flex flex-col items-center mb-0 max-w-full  max-md:mb-2.5">

              <h2 className="text-3xl kuunari-bold tracking-wide leading-loose text-center text-white">
                Meet the Team
              </h2>
              <div className="mt-6 max-w-full w-[440px]">
                <div className="flex gap-5 max-md:flex-col">
                  <div className="w-6/12 max-md:ml-0 max-md:w-full">
                    <TeamMember
                      imageSrc={GeoffHill}
                      name="Geoff Hill"
                      title="NZ Sales Manager"
                      email="Geoff@TuataraATV.com"
                      phone="(+64) 274 770 070"
                    />
                  </div>
                  <div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                    <TeamMember
                      imageSrc={MichelleMorton}
                      name="Michelle Morton"
                      title="Parts Manager"
                      email="office@Tuataraatv.com"
                      phone="022 126 5018"
                    />
                    {/* <div className="flex flex-col items-center text-base text-center text-white max-md:mt-10">
                      <img
                        src={MichelleMorton}
                        alt="Michelle Morton"
                        className="object-contain self-stretch w-full aspect-square"
                      />
                      <h4 className="mt-6 font-semibold leading-loose">
                        Michelle Morton
                      </h4>
                      <div className="mt-2 font-medium leading-6">
                        Parts Manager
                        <br />
                        <span style={{ color: "rgba(247,135,27,1)" }}>
                          office@Tuataraatv.com
                        </span>
                        <br />
                        <span style={{ color: "rgba(247,135,27,1)" }}>
                          022 126 5081
                        </span>
                      </div>
                    </div> */}
                  </div>
                </div>
              </div>
              <div className="mt-7 max-w-full w-[443px]">
                <div className="flex gap-5 max-md:flex-col">
                  <div className="w-6/12 max-md:ml-0 max-md:w-full">
                    <TeamMember
                      imageSrc={QingmeiPang}
                      name="Qingmei Pang"
                      title="Technical Manager"
                      email="qingmei@tuataraatv.com"
                      phone="027 665 5077"
                    />
                  </div>
                  <div className="ml-5 w-6/12 max-md:ml-0 max-md:w-full">
                    <TeamMember
                      imageSrc={User_Icon}
                      name=""
                      title="Office & Sales Support"
                      email="pa@tuataraatv.com"
                      phone="022 308 8996"
                    />
                  </div>
                </div>
              </div>
              <h2 className="mt-8 text-3xl font-bold tracking-wide leading-loose text-center text-white kuunari-bold">
                Get In Touch
              </h2>
              <p className="self-stretch mt-6 text-base leading-6 text-center text-white max-md:max-w-full">
                If you have any questions about our Tuatara ATV/UTV or any of our other products, just complete the contact form, and we will respond to you very promptly.
                <br />
                <br />
                Please use our CONTACT FORM for all New Zealand and International enquiries. We will respond quickly by phone or email.
              </p>
            </div>
            {/* </div> */}
            {/* <div className="lg:text-start text-center">
              <div className="kuunari-bold text-[30px] text-white">Get in Touch</div>
              <p className="montserrat-regular text-white text-[16px] leading-[24px]">
                If you have any quetions about the TUATARA ATV or any of our other products, just send us a message
                including your contact details and the nature of your enquiry.
              </p>
              <p className="montserrat-regular text-white text-[16px] leading-[24px]">
                Please use out CONTACT FORM for all New Zealand and International enuiries. We will resond quickly by
                phone or email.
              </p>
            </div>
            <div className="text-center">
              <div className="text-center flex items-center justify-center mb-[19px]">
                <img src={MichelleMorton} alt="MichelleMorton" className="w-[150px]" />
              </div>
              <div className="text-center text-[16px] leading-[36px] text-white montserrat-medium">Michelle Morton</div>
              <div className="text-center text-[16px] leading-[24px] text-white montserrat-medium">
                Parts, Warranty & Office Administrator
              </div>
              <div className="text-center">
                <a
                  href="mailto:office@TuataraATV.com"
                  className="text-[16px] leading-[24px] text-[#F7871B] montserrat-medium"
                >
                  office@TuataraATV.com
                </a>
              </div>
            </div>
            <div className="text-center">
              <div className="text-center flex items-center justify-center mb-[19px]">
                <img src={GeoffHill} alt="GeoffHill" className="w-[150px]" />
              </div>
              <div className="text-center text-[16px] leading-[36px] text-white montserrat-medium">Geoff Hill</div>
              <div className="text-center text-[16px] leading-[24px] text-white montserrat-medium">
                NZ Sales Manager
              </div>
              <div className="text-center">
                <a
                  href="mailto:Geoff@TuataraATV.com"
                  className="text-[16px] leading-[24px] text-[#F7871B] montserrat-medium"
                >
                  Geoff@TuataraATV.com
                </a>
              </div>
            </div> */}
          </div>
          {/* <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 gap-3 mt-[50px]">
            <div className="lg:text-start text-center">
              <div className="kuunari-bold text-[30px] text-white">CONTACT US</div>
              <p className=" montserrat-medium text-[14px] text-[#ffffff]">
                <a
                  href="www.google.com/maps/place/Tuatara+ATV/@-43.5578351,172.377284,15z/data=!4m10!1m2!2m1!1stuatara!3m6!1s0x6d321d3631fd0ee3:0xcae1a6a167efd8d3!8m2!3d-43.5578351!4d172.3963384!15sCgd0dWF0YXJhWgkiB3R1YXRhcmGSARdmYXJtX2VxdWlwbWVudF9zdXBwbGllcuABAA!16s%2Fg%2F1tp1y_mp?authuser=0&amp;entry=ttu"
                  target="_blank"
                  className="text-[#E09900] "
                >
                  291 Weedons Ross Road,
                  <br /> R.D. 5,
                  <br />
                  Christchurch 7675
                  <br />
                  New Zealand
                </a>
              </p>
              <p className=" montserrat-medium text-[14px]">
                {" "}
                <a href="tel:+6433474956" target="_blank" className="text-[#E09900]">
                  (+64) 3 347 4956
                </a>
              </p>
              <p className=" montserrat-medium text-[14px]">
                {" "}
                <a href="tel:+64274770070" target="_blank" className="text-[#E09900]">
                  (+64)274770070
                </a>
              </p>
              <p className=" montserrat-medium text-[14px]">
                {" "}
                <a href="mailto:info@tuataraatv.com" target="_blank" className="text-[#E09900]">
                  info@tuataraatv.com
                </a>
              </p>
            </div>{" "}
            <div className="text-center">
              <div className="kuunari-bold text-[30px] text-white">Hours</div>
              <p className=" montserrat-medium text-[14px] text-[#ffffff]">
                Mon:8am - 5pm
                <br />
                Tue:8am - 5pm
                <br />
                Wed:8am - 5pm
                <br />
                Thur:8am - 5pm
                <br />
                Fri:8am - 5pm
                <br />
                Sat:8am - 5pm
                <br />
                Sun:8am - 5pm
              </p>
            </div>
          </div> */}
        </div>
      </div>
      <div className="footer-nz">
        <div className="lg:p-[70px] md:p-[30px] p-[10px]">
          <div className="kuunari-bold text-white mb-[10px] text-[30px] leading-[68px]">
            Send A message
          </div>{" "}
          <div className="montserrat-medium text-[#A8A6A6] mb-[10px] text-[16px] ">
            "<span className="text-[#b02f1b]">*</span>" indicates required
            fields
          </div>{" "}
          <Formik
            initialValues={{
              name: "",
              lastname: "",
              email: "",
              phone: "",
              message: "",
              bname: "",
              reCaptcha: "",
              subject: "",
            }}
            validationSchema={AccSchema}
            onSubmit={(values, { resetForm }) => {
              handleSubmitForm(values, resetForm);
            }}
          >
            {({
              errors,
              touched,
              values,
              handleSubmit,
              handleChange,
              setFieldValue,
            }) => (
              <form onSubmit={handleSubmit}>
                <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                  Name <span className="text-[#b02f1b] font">*</span>
                </label>
                <div className="grid grid-cols-2 gap-x-[25px] pt-[13px]">
                  <div className="mb-[25px]">
                    <input
                      className="w-full text-[12px] p-[10px]"
                      name="name"
                      value={values.name}
                      onChange={handleChange}
                    />
                    <div className="text-[14px] text-[#A8A6A6]  montserrat-medium">
                      First
                    </div>
                    {errors.name && touched.name && (
                      <div
                        style={{ fontSize: 14, textAlign: "left" }}
                        className=" mt-1 text-red-600"
                      >
                        {errors.name}
                      </div>
                    )}
                  </div>
                  <div className="mb-[25px]">
                    <input
                      className="w-full text-[12px] p-[10px]"
                      name="lastname"
                      value={values.lastname}
                      onChange={handleChange}
                    />
                    <div className="text-[14px] text-[#A8A6A6]  montserrat-medium">
                      Last
                    </div>
                    {errors.lastname && touched.lastname && (
                      <div
                        style={{ fontSize: 14, textAlign: "left" }}
                        className=" mt-1 text-red-600"
                      >
                        {errors.lastname}
                      </div>
                    )}
                  </div>
                </div>

                <div className="mb-[25px]">
                  <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                    Business Name
                  </label>
                  <input
                    className="w-full text-[12px] p-[10px] mt-[13px]"
                    name="bname"
                    value={values.bname}
                    onChange={handleChange}
                  />
                  {errors.bname && touched.bname && (
                    <div
                      style={{ fontSize: 14, textAlign: "left" }}
                      className=" mt-1 text-red-600"
                    >
                      {errors.bname}
                    </div>
                  )}
                </div>

                <div className="grid grid-cols-2 gap-x-[25px]">
                  <div className="mb-[25px]">
                    <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                      Email <span className="text-[#b02f1b] font">*</span>
                    </label>
                    <input
                      className="w-full text-[12px] p-[10px] mt-[13px]"
                      name="email"
                      value={values.email}
                      onChange={handleChange}
                    />
                    {errors.email && touched.email && (
                      <div
                        style={{ fontSize: 14, textAlign: "left" }}
                        className=" mt-1 text-red-600"
                      >
                        {errors.email}
                      </div>
                    )}
                  </div>
                  <div className="mb-[25px]">
                    <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                      Phone <span className="text-[#b02f1b] font">*</span>
                    </label>
                    <input
                      className="w-full text-[12px] p-[10px] mt-[13px]"
                      name="phone"
                      value={values.phone}
                      onChange={handleChange}
                      type="number"
                    />
                    {errors.phone && touched.phone && (
                      <div
                        style={{ fontSize: 14, textAlign: "left" }}
                        className=" mt-1 text-red-600"
                      >
                        {errors.phone}
                      </div>
                    )}
                  </div>
                </div>
                <div className="mb-[25px]">
                  <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                    Subject <span className="text-[#b02f1b] font">*</span>
                  </label>
                  <input
                    className="w-full text-[12px] p-[10px] mt-[13px]"
                    name="subject"
                    value={values.subject}
                    onChange={handleChange}
                  />
                  {errors.subject && touched.subject && (
                    <div
                      style={{ fontSize: 14, textAlign: "left" }}
                      className=" mt-1 text-red-600"
                    >
                      {errors.subject}
                    </div>
                  )}
                </div>

                <div className="mb-[25px]">
                  <label className="montserrat-medium text-white text-[16px]  montserrat-medium">
                    Message <span className="text-[#b02f1b] font">*</span>
                  </label>
                  <textarea
                    rows="6"
                    className="w-full text-[12px] p-[10px] mt-[13px]"
                    name="message"
                    value={values.message}
                    onChange={handleChange}
                  />
                  {errors.message && touched.message && (
                    <div
                      style={{ fontSize: 14, textAlign: "left" }}
                      className=" mt-1 text-red-600"
                    >
                      {errors.message}
                    </div>
                  )}
                </div>

                <div className="text-center flex items-center justify-center flex-col my-5">
                  <ReCAPTCHA
                    ref={reCaptchaRef}
                    size="normal"
                    sitekey={"6LdhUSMqAAAAANByfdbSyhgGZS1-SeDIVDPAq7rb"}
                    onChange={(captchaCode) => {
                      setFieldValue("reCaptcha", captchaCode);
                      // onReCAPTCHAChange
                    }}
                  />

                  {errors.reCaptcha && touched.reCaptcha && (
                    <div
                      style={{ fontSize: 14, textAlign: "left" }}
                      className=" mt-1 text-red-600"
                    >
                      {errors.reCaptcha}
                    </div>
                  )}
                </div>

                <div className="text-center m-auto">
                  <button
                    className={`montserrat-medium bg-[#000] p-3 text-white mx-auto flex items-center justify-center ${isLoading ? "opacity-50 cursor-not-allowed" : ""
                      }`}
                    type="submit"
                    disabled={isLoading}
                  >
                    {isLoading ? (
                      <>
                        <svg
                          className="animate-spin h-5 w-5 mr-2 text-white"
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                        >
                          <circle
                            className="opacity-25"
                            cx="12"
                            cy="12"
                            r="10"
                            stroke="currentColor"
                            strokeWidth="4"
                          ></circle>
                          <path
                            className="opacity-75"
                            fill="currentColor"
                            d="M4 12a8 8 0 018-8v8H4z"
                          ></path>
                        </svg>
                        SENDING...
                      </>
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </form>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};
export default NZContact;
